import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["name", "label", "className", "disabled", "lang", "haveLabel", "placeholder", "inputWrapperClassName", "direction", "maxLength"];
import React from "react";
var __jsx = React.createElement;
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "@i18n";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import { CDN_LINK } from "@globalConfig";
import { useState, useEffect } from "react";
import { twMerge } from "tailwind-merge";
// Helper to get dynamic maxLength based on phone format
var getDynamicMaxLength = function getDynamicMaxLength(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  if (value.startsWith('05')) return 10;
  if (value.startsWith('5')) return 9;
  return fallback;
};

// Inner component to handle local state

function PhoneInputWrapper(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    error = _ref.error,
    disabled = _ref.disabled,
    className = _ref.className,
    lang = _ref.lang,
    direction = _ref.direction,
    haveLabel = _ref.haveLabel,
    placeholder = _ref.placeholder,
    inputWrapperClassName = _ref.inputWrapperClassName,
    maxLength = _ref.maxLength,
    inputProps = _ref.inputProps;
  var _useState = useState(value || ""),
    localValue = _useState[0],
    setLocalValue = _useState[1];
  // Key to force re-render of InputPhoneNumber when value is trimmed
  var _useState2 = useState(0),
    inputKey = _useState2[0],
    setInputKey = _useState2[1];

  // Sync local state with form value
  useEffect(function () {
    setLocalValue(value || "");
  }, [value]);

  // Wrap onChange to enforce dynamic maxLength based on phone format
  var handleChange = function handleChange(newValue) {
    var dynamicMaxLength = getDynamicMaxLength(newValue, maxLength || 10);

    // Check if we need to trim
    if (newValue.length > dynamicMaxLength) {
      var trimmedValue = newValue.slice(0, dynamicMaxLength);
      setLocalValue(trimmedValue);
      onChange(trimmedValue);
      // Force re-render of InputPhoneNumber to sync the trimmed value
      setInputKey(function (prev) {
        return prev + 1;
      });
    } else {
      setLocalValue(newValue);
      onChange(newValue);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start [&_.inputWrapper]:border [&_.inputWrapper]:border-solid en:flex-row-reverse"
  }, /*#__PURE__*/React.createElement(InputPhoneNumber, _extends({
    key: inputKey,
    defaultValue: localValue,
    onChange: handleChange,
    onBlur: onBlur,
    errorLabel: error || "",
    disabled: disabled,
    inputClassName: className,
    lang: lang,
    direction: direction || "ltr",
    haveLabel: haveLabel,
    placeholder: placeholder,
    inputWrapperClassName: twMerge("!border !border-solid !rounded-lg !border-gray-echo !rounded-tl-none !rounded-bl-none", inputWrapperClassName),
    errorLabelClassName: "!text-[#F22C2C] !m-1"
  }, inputProps)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 py-1.5 px-3 rounded-lg border border-solid border-gray-echo rounded-tr-none rounded-br-none en:border-r-0 en:border-solid en:ml-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-sm leading-4 text-black-primary"
  }, "+966"), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saudi-flag.svg",
    width: 32,
    height: 32,
    alt: "saudi flag"
  })));
}
export function RHFInputPhoneNumber(_ref2) {
  var name = _ref2.name,
    label = _ref2.label,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$lang = _ref2.lang,
    lang = _ref2$lang === void 0 ? "ar" : _ref2$lang,
    _ref2$haveLabel = _ref2.haveLabel,
    haveLabel = _ref2$haveLabel === void 0 ? true : _ref2$haveLabel,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? "" : _ref2$placeholder,
    _ref2$inputWrapperCla = _ref2.inputWrapperClassName,
    inputWrapperClassName = _ref2$inputWrapperCla === void 0 ? "" : _ref2$inputWrapperCla,
    direction = _ref2.direction,
    maxLength = _ref2.maxLength,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref3) {
      var _ref3$field = _ref3.field,
        onChange = _ref3$field.onChange,
        value = _ref3$field.value,
        onBlur = _ref3$field.onBlur,
        error = _ref3.fieldState.error;
      return /*#__PURE__*/React.createElement(PhoneInputWrapper, {
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        error: error ? tShort(error.message, {
          ns: "validations"
        }) : "",
        disabled: disabled,
        className: className,
        lang: lang,
        direction: direction,
        haveLabel: haveLabel,
        placeholder: placeholder,
        inputWrapperClassName: inputWrapperClassName,
        maxLength: maxLength,
        inputProps: inputProps
      });
    }
  });
}
export default RHFInputPhoneNumber;